import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure26 = {
  chart: {
      zoomType: 'xy',
      animation: false,
      marginTop: 50,
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      height: 500,
      type: 'pie',
      backgroundColor: 'rgba(255, 255, 255, 0.0)',
      style: {
        fontFamily: 'Montserrat'
      }
  },
  colors: ['#ffc000', '#bfbfbf', '#00b050', '#ff0000'],
  credits: {
      enabled: false
  },
  title: {
      text: null
  },
  subtitle: {
      text: null
  },

  plotOptions: {
      series: {
          colorByPoint: true,
          borderWidth: 0
      },
      pie: {
          dataLabels: {
              format: '{point.name} <br /> {point.percentage:.1f}%',
              distance: -50,
              enabled: true
          }
      }
  },

  exporting: {
      enabled: false
  },
  tooltip: {
      headerFormat: '<h5 style="font-size:18px; font-weight: normal;">{point.key}</h5>',
      pointFormat: '<b>{point.percentage}%</b>',
      shared: true,
      useHTML: true,
      hideDelay: 500,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      style: {
          padding: 0
      },
      formatter: function () {
          return this.point.name + ': <b>' + Highcharts.numberFormat(this.percentage, 1) + '%</b>';
      },
  },
  accessibility: {
      point: {
          valueSuffix: '%'
      }
  },

  series: [{
      size: 260,
      startAngle: 20,
      center: [200, 130],
      data: [{
          name: "Niveau de risque connu", y: 38, custom: '2761', color: '#ffc000'
        }, {
          name: "Niveau de risque non connu", y: 62, custom: '4839', color: '#bfbfbf'
        }
      ],
  },{
      size: 200,
      center: [600, 130],
      startAngle: 60,
      data: [
          {
              name: "Non menacées", y: 27.7, custom: '2025', color: '#00b050'
            },
          {
          name: "Menacées", y: 72.3, custom: '736', color: '#ff0000'
        }
      ],
  }]
}
